import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionDataService } from './../services/session-data.service';
import { UtilitiesService } from './utilities.service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(
    private sessionDataService: SessionDataService,
    private UTS: UtilitiesService
  ) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const data = localStorage.getItem('TR') && JSON.parse(localStorage.getItem('TR')) || '';
      let CSRF = request.headers != null ? request.headers.get("X-CSRF-TOKEN") : null;
      let header = {
        Channel: this.UTS.getENV().toLocaleUpperCase(),
        transactionId: Date.now().toString(),
        "content-type": "application/json",
        'Accept-Encoding': "UTF-8",
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "If-Modified-Since": "0"
      };
      if (CSRF && CSRF != '') {
        header["X-CSRF-TOKEN"] = CSRF;
      }
      const cqToken =  data && data.cqToken || ''
      if(cqToken && cqToken != ''){
        header['cqToken'] = cqToken;
      }
      header['transactionId'] = Date.now().toString();

      const isWebView = sessionStorage.getItem('isWebView') == 'true' ? true : false;
      const isEjariAppFlow = sessionStorage.getItem('ejariApp') == 'true' ? true : false;
      const isTeleSalesFlow = (sessionStorage.getItem('elife_teleSales') == 'true') || (sessionStorage.getItem('postpaid_teleSales') == 'true') ? true : false;
      if (isWebView) {
        header['Channel'] = 'MobileWebView';
      } else if (isEjariAppFlow) {
        header['Channel'] = 'Ejari';
      } else if (isTeleSalesFlow) {
        header['Channel'] = 'CS-Telesales';
      } else {
        header['Channel'] = 'Ecare';
      }
      const subChannel = sessionStorage.getItem('subChannel');
      if (subChannel) {
        header['subChannel'] = subChannel;
      }
      if (isTeleSalesFlow){
         header['subChannel'] = 'IndirectSale';
      }
      request = request.clone({
        headers: new HttpHeaders(header),
        withCredentials: true,
      });

    return next.handle(request);
  }
}
